import "antd/es/input/style";
import _Input from "antd/es/input";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import formMethods from '../utils/form-methods';
import omit from 'omit.js';
import { ShowOutlined, HideOutlined } from 'iglooicon';
var Password = _Input.Password;

var IglooPassword = function IglooPassword(props) {
  return _jsx(Password, _objectSpread(_objectSpread({
    className: "igloo-input"
  }, omit(props, formMethods)), {}, {
    iconRender: function iconRender(visible) {
      return visible ? _jsx(ShowOutlined, {
        style: {
          fontSize: 22,
          color: '#666666'
        }
      }) : _jsx("span", {
        onClickCapture: function onClickCapture(e) {
          if (!props.value) {
            e.stopPropagation();
          }
        },
        children: _jsx(HideOutlined, {
          style: {
            fontSize: 22,
            color: props.value ? '#666666' : '#bdbdbd',
            cursor: props.value ? 'pointer' : 'not-allowed'
          }
        })
      });
    }
  }));
};

IglooPassword.formItemPropsHandler = function (config) {
  return {};
};

export default IglooPassword;